import axios from 'axios';
import { authToken } from '../API.js';

export default {
    createRetailCards: async (num) => {
        return await axios.post(`/api/admin/randkey/${num}`);
    },

    // -----------------------------------------------------
    // ------------------START GET ROUTES-------------------
    // -----------------------------------------------------

    // Sends user password reset link if the email matches a known auth user object
    passwordReset: async (data) => {
        return await axios.post('/api/admin/passwordReset', data);
    },

    // Get randkey for retail card
    getRetailCard: async (retailKey) => {
        return await axios.get(`/api/admin/randkey/${retailKey}`);
    },

    getUserByEmail: async (email) => {
        return await axios.get(`/api/admin/email/${email}`);
    },

    // Gets a single user by their uid
    getUserByUIDAdmin: async (uid) => {
        return await axios.get(`/api/admin/${uid}`);
    },

    getUserAnalytics: async (uid) => {
        return await axios.get(`/api/admin/stats/${uid}`);
    },

    // Gets a single user by their username
    getUserByUsername: async (username) => {
        return await axios.get(`/api/admin/username/${username}`);
    },
    
    getAuthEmailByUID: async (uid) => {
        return await axios.get(`/api/admin/auth/email/${uid}`);
    },

    getEnterpriseExistsBoolean: async (entName) => {
        return await axios.get(`/api/admin/enterprise/exists/${entName}`);
    },

    getGeneratorObj: async (token)=> {
        return await axios.get(`/api/admin/generator/${token}`);
    },

    // -----------------------------------------------------
    // ------------------START POST ROUTES------------------
    // -----------------------------------------------------

    createNewEnterprise: async (data) => {
        return await axios.post(`/api/admin/enterprise/create`, data);
    },

    createNewEnterpriseExistingUser: async (data) => {
        return await authToken().then(async (token) => {
            const config = {
                headers: { Authorization: `Bearer ${token}`}
            };

            return await axios.post(`/api/admin/enterprise/create/existing`, data, config);
        });
    },

    createUserFromGenerator: async (data) => {
        return await axios.post(`/api/admin/generator/signup`, data);
    },

    liquidEntSignup: async (data) => {
        return await authToken().then(async (token) => {
            const config = {
                headers: { Authorization: `Bearer ${token}`}
            };

            return await axios.post('/api/admin/liquidqr/ent', data, config);
        });
    },

    // -----------------------------------------------------
    // ------------------START PUT ROUTES-------------------
    // -----------------------------------------------------
    getThemeTemplates: async () => {
        return await axios.get(`/api/admin/theme_templates`);
    },

    updateVcardObj: async (uid, data) => {
        return await axios.put(`/api/admin/vcard/${uid}`, data);
    },

    updateRetailCard: async (retailKey, data) => {
        return await axios.put(`/api/admin/randkey/${retailKey}`, data);
    },

    completeAccountRegistration: async (data) => {
        return await axios.put('/api/admin/username', data);
    },

    upgradeProUser: async (data) => {
        return await axios.put('/api/admin/proUpgrade', data);
    },

    // -----------------------------------------------------
    // -----------------START DELETE ROUTES-----------------
    // -----------------------------------------------------

    deleteUser: async (uid, username) => {
        return await axios.delete(`/api/admin/delete/${uid}/${username}`);
    },
};